import LogoFull from "../header/LogoFull.js";
import MobileNav from "../header/MobileNav.js";
import Hamburger from "../header/Hamburger.js";

function HeaderMobile() {
  return (
    <header className="fixed inset-0 bottom-auto px-6 pt-5 pb-10 z-20 flex justify-between items-center bg-header-gradient">
      <LogoFull />
      <Hamburger />
      <MobileNav />
    </header>
  );
}

export default HeaderMobile;
